import { createContext, useContext } from 'react'
import { type FilterParamsState } from './filterParams.types'

export const FilterParamsContext = createContext<FilterParamsState>(undefined)

export const useFilterParamsContext = () => useContext(FilterParamsContext)
